import styles from './SubscriptionPaymentPlans.module.scss';

import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useCheckout } from 'components/Checkout/CheckoutProvider';
import { Installments, Plans } from '../types';
import { PaymentPlanSelection } from './PaymentPlanSelection/PaymentPlanSelection';
import { SubtotalTitle } from 'components/Cart/OrderSummary/SubtotalTitle/SubtotalTitle';
import { getTotalSubscriptionMonthlyHardwarePrice } from 'components/Cart/InYourCart/utils/getTotalSubscriptionMonthlyPrice';
import { useCartContext } from 'components/Cart/hooks/useCartContext';

export const SubscriptionPaymentPlans: FC = () => {
  const { t } = useTranslation();
  const { selectedPurchaseType, setSelectedPurchaseType } = useCheckout();
  const { checkout } = useCartContext();

  const subscriptionPlans: Plans = [
    {
      term: Installments.SL36,
      price: getTotalSubscriptionMonthlyHardwarePrice(Installments.SL36, checkout) || 0,
    },
    {
      term: Installments.SL48,
      price: getTotalSubscriptionMonthlyHardwarePrice(Installments.SL48, checkout) || 0,
    },
  ];

  return (
    <>
      <SubtotalTitle summaryTitle={t('order-summary.title-caps')} isCheckout={false} />
      <form className={styles.options}>
        {subscriptionPlans
          .filter(subscriptionPlan => subscriptionPlan.price > 0)
          .map(subscriptionPlan => (
            <PaymentPlanSelection
              onChange={() => setSelectedPurchaseType(subscriptionPlan.term)}
              checked={subscriptionPlan.term === selectedPurchaseType}
              key={subscriptionPlan.term}
              plan={subscriptionPlan}
              id={`plan-select-${subscriptionPlan.term}`}
            />
          ))}
      </form>
    </>
  );
};
